import React, { useState, Suspense, useEffect, useCallback } from "react";
import Map from "./Map";
import LeftSideSummary from "./LeftSideSummary";
import { useLocalStorage, useSessionStorage, useWindowSize } from "react-use";
import axios from "axios";
import { ReactTyped } from "react-typed";
import { useLocation, useNavigate } from "react-router-dom";
import "./Home.css";
import { useCubeQuery } from "@cubejs-client/react";
import {
    handleQueryFilters,
    handleDistrictQueryFilters,
    ClientWiseStateQuery,
    handleClientDataQueryModality
} from "./utils";
import cubejs from "@cubejs-client/core";
import { STATISTIC_CONFIGS, STATE_NAMES } from "../constants";
import MapTool from "./MapTool";
import ClientsTable from "./ClientsTable";
import { MdOutlineLogout } from "react-icons/md";
import { BsClipboard2DataFill } from "react-icons/bs";


// import MapExplorer from './MapExplorer';

function Home({ handleLogout, email, accessLevel, accessList }) {
    const navigate = useNavigate()
    let count = 1;
    const [regionHighlighted, setRegionHighlighted] = useState({
        stateCode: "TT",
        districtName: null,
        value: "",
    });
    const [mapStatistic, setMapStatistic] = useSessionStorage(
        "mapStatistic",
        "clients"
    );
    const [clientTableExpand, setClientTableExpand] = useState({
        state: 'TT',
        district: null,
        stage: "prospects",
    });
    const [indiaCard, setIndiaCard] = useState(null);
    const [districtData, setDistrictData] = useState([]);
    const [modalityData, setModalityData] = useState([]);
    const [cardData, setCardData] = useState({});
    const [clientData, setClientData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [modalityCheck, setModalityCheck] = useState([
        // "XRAY",
        // "CT",
        // "MRI",
        // "NM",
    ]);
    const [theme, setTheme] = useState("light-theme");
    const [modalityDistrictData, setModalityDistrictData] = useState([]);
    const [mapCode, setMapCode] = useState("TT");
    const [districtView, setDistrictView] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [data, setData] = useState([]);
    const [mapData, setMapData] = useState([]);
    const [districtMapData, setMapDistrictData] = useState({});
    useEffect(() => {
        // handleGetData()
        // handleDistrictData()
        // getClientList()
        if (email) {
            if (email === 'rajeshm@cancercentersofamerica.in') {
                setModalityCheck(['NM'])
            } else {
                setModalityCheck(["XRAY",
                    "CT",
                    "MRI",
                    "NM"])
            }
        }
    }, [email]);

    useEffect(() => {

        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );

        const fetchStateData = async () => {
            try {
                await cubejsApi
                    .load(handleQueryFilters(modalityCheck, email, accessLevel))
                    .then((resultSet) => {
                        // Pivot the data here
                        const pivotedData = resultSet.tablePivot({
                            x: ["master.state", "measures"],
                            y: ["master.status"],
                        });
                        // //console.log(pivotedData)
                        setData(pivotedData);
                    })
                    .catch((error) => {
                        console.error("Error fetching API response:", error);
                    });
            } catch (error) {
                console.error("Error fetching API response:", error);
            }
        };

        const fetchDistrictData = async () => {
            try {
                await cubejsApi
                    .load(handleDistrictQueryFilters(modalityCheck, email, accessLevel))
                    .then((resultSet) => {
                        // Pivot the data here
                        const pivotedData = resultSet.tablePivot({
                            x: ["master.state", "marster.district", "measures"],
                            y: ["master.status"],
                        });
                        setModalityDistrictData(pivotedData);
                    })
                    .catch((error) => {
                        console.error("Error fetching API response:", error);
                    });
            } catch (error) {
                console.error("Error fetching API response:", error);
            }
        };

        const fetchClientDataState = async (limit, offset) => {
            try {
                await cubejsApi
                    .load({ ...handleClientDataQueryModality(modalityCheck, email, accessLevel), limit: limit, offset: offset })
                    .then((resultSet) => {
                        // setModalityDistrictData(pivotedData)

                        let modalityFilterData = resultSet?.loadResponses[0]?.data?.map(
                            (item) => {
                                const stateName = item["master.state"];
                                const stateCode = Object.keys(STATE_NAMES).find(
                                    (key) => STATE_NAMES[key] === stateName
                                );
                                return {
                                    ...item,
                                    stateCode: stateCode || "UNASSIGNED",
                                };
                            }
                        );
                        if (resultSet?.loadResponses[0]?.data?.length === 25000) {
                            fetchClientDataState(limit, offset + 25001);
                        }

                        setClientList((prev) => [...prev, ...modalityFilterData]);
                        // setClientData(modalityFilterData)
                    })
                    .catch((error) => {
                        console.error("Error fetching API response:", error);
                    });
            } catch (error) {
                console.error("Error fetching API response:", error);
            }
        };
        setClientList([])
        if (modalityCheck?.length > 0 && accessLevel && email) {
            setClientList([])
            fetchStateData();
            fetchDistrictData();
            fetchClientDataState(25000, 0);
            //     count = 2;
        }
    }, [modalityCheck, email, accessLevel]);


    useEffect(() => {
        if (clientList) {
            setClientData(getDistinctItems(clientList))
        } else {
            setClientData([])
        }

    }, [clientList])

    const getDistinctItems = (items) => {
        const seen = new Set();
        return items.filter(item => {
            const key = `${item['master.client_name']}-${item['master.address']}-${item['master.district']}-${item['master.state']}-${item['master.status']}`;
            if (!seen.has(key)) {
                seen.add(key);
                return true;
            }
            return false;
        });
    };

    // function removeDuplicates(list) {
    //     const uniqueObjects = [];
    //     const seen = {}; // Object to keep track of unique combinations of values

    //     for (const obj of list) {
    //         // //console.log(obj)
    //         // Create a unique key based on the values of all four columns
    //         const key = `${obj['master.client_name']}-${obj['master.address']}-${obj['master.district']}-${obj['master.state']}-${obj['stateCode']}`;
    //         //  //console.log(key)
    //         // If the key is not seen before, add the object to the new array and mark the key as seen
    //         if (!seen[key]) {
    //             uniqueObjects.push(obj);
    //             seen[key] = true;
    //         }
    //     }

    //     return uniqueObjects;
    // }

    const statisticConfig = STATISTIC_CONFIGS[mapStatistic];

    const transformStatistic = useCallback(
        (val) =>
            statisticConfig?.mapConfig?.transformFn
                ? statisticConfig.mapConfig.transformFn(val)
                : val,
        [statisticConfig]
    );

    const accumulateValuesByState = (data, key) => {
        const accumulatedValues = {};
        data.forEach((item) => {
            const stateCode = item.stateCode;
            const value = item[key];
            if (accumulatedValues[stateCode]) {
                accumulatedValues[stateCode] += value;
            } else {
                accumulatedValues[stateCode] = value;
            }
        });
        return accumulatedValues;
    };

    // Function to convert accumulated values object into array of objects
    const convertToObjectArray = (accumulatedValues) => {
        const result = [];
        for (const stateCode in accumulatedValues) {
            result.push({ [stateCode]: accumulatedValues[stateCode] });
        }
        return result;
    };

    useEffect(() => {
        if (data) {
            if (districtView) {
                // modalityFilterData=handleModalityChange(modalityFilterData)

                let modalityFilterData = modalityDistrictData?.map((item) => {
                    const stateName = item["master.state"];
                    const stateCode = Object.keys(STATE_NAMES).find(
                        (key) => STATE_NAMES[key] === stateName
                    );
                    return {
                        ...item,
                        stateCode: stateCode || "UNASSIGNED",
                    };
                });

                modalityFilterData = modalityFilterData?.map((item) => {
                    return {
                        ...item,
                        onboarded_clients: parseInt(item.ACTIVE) + parseInt(item.INACTIVE),
                        state: item["master.state"],
                        potential_clients: parseInt(item.POTENTIAL),
                        total:
                            parseInt(item.ACTIVE) +
                            parseInt(item.INACTIVE) +
                            parseInt(item.POTENTIAL),
                        ACTIVE: parseInt(item.ACTIVE),
                        INACTIVE: parseInt(item.INACTIVE),
                    };
                });

                const client = modalityFilterData
                    ?.filter((data) => data.stateCode === mapCode)
                    ?.reduce((total, val) => total + val?.potential_clients, 0);
                const onboard = modalityFilterData
                    ?.filter((data) => data.stateCode === mapCode)
                    ?.reduce((total, val) => total + val?.onboarded_clients, 0);
                const active = modalityFilterData
                    ?.filter((data) => data.stateCode === mapCode)
                    ?.reduce((total, val) => total + val?.ACTIVE, 0);
                const inactive = modalityFilterData
                    ?.filter((data) => data.stateCode === mapCode)
                    ?.reduce((total, val) => total + val?.INACTIVE, 0);
                const total = modalityFilterData
                    ?.filter((data) => data.stateCode === mapCode)
                    ?.reduce((total, val) => total + val?.total, 0);
                setCardData({
                    client,
                    onboard,
                    active,
                    inactive,
                    total,
                });
            } else {
                let modalityFilterData = data?.map((item) => {
                    const stateName = item["master.state"];
                    const stateCode = Object.keys(STATE_NAMES).find(
                        (key) => STATE_NAMES[key] === stateName
                    );
                    return {
                        ...item,
                        stateCode: stateCode || "UNASSIGNED",
                    };
                });

                modalityFilterData = modalityFilterData?.map((item) => {
                    return {
                        ...item,
                        onboarded_clients: parseInt(item.ACTIVE) + parseInt(item.INACTIVE),
                        state: item["master.state"],
                        potential_clients: parseInt(item.POTENTIAL),
                        total:
                            parseInt(item.ACTIVE) +
                            parseInt(item.INACTIVE) +
                            parseInt(item.POTENTIAL),
                        ACTIVE: parseInt(item.ACTIVE),
                        INACTIVE: parseInt(item.INACTIVE),
                    };
                });

                const client = modalityFilterData?.reduce(
                    (total, val) => total + val?.potential_clients,
                    0
                );
                const onboard = modalityFilterData?.reduce(
                    (total, val) => total + val?.onboarded_clients,
                    0
                );
                const active = modalityFilterData?.reduce(
                    (total, val) => total + val?.ACTIVE,
                    0
                );
                const inactive = modalityFilterData?.reduce(
                    (total, val) => total + val?.INACTIVE,
                    0
                );
                const total = modalityFilterData?.reduce(
                    (total, val) => total + val?.total,
                    0
                );
                setCardData({
                    client,
                    onboard,
                    active,
                    inactive,
                    total,
                });
                setIndiaCard({
                    client,
                    onboard,
                    active,
                    inactive,
                    total,
                });
            }
        }
    }, [
        data,
        mapCode,
        districtView,
        modalityCheck,
        modalityData,
        modalityDistrictData,
    ]);

    const handleModalityChange = (modality) => {
        const duplicateData = JSON.parse(JSON.stringify(modality));
        const mergedData = duplicateData?.reduce((acc, curr) => {
            const existingItem = acc.find(
                (item) => item.stateCode === curr.stateCode
            );
            if (existingItem) {
                Object.keys(curr).forEach((key) => {
                    if (key !== "state") {
                        if (key === "stateCode") {
                        } else {
                            existingItem[key] += curr[key] ? curr[key] : 0;
                        }
                    }
                });
            } else {
                acc.push(curr);
            }
            return acc;
        }, []);
        return mergedData;
    };

    useEffect(() => {
        if (data) {
            let modalityFilterData = data?.map((item) => {
                const stateName = item["master.state"];
                const stateCode = Object.keys(STATE_NAMES).find(
                    (key) => STATE_NAMES[key] === stateName
                );
                return {
                    ...item,
                    stateCode: stateCode || "UNASSIGNED",
                };
            });

            modalityFilterData = modalityFilterData?.map((item) => {
                return {
                    ...item,
                    onboarded_clients: parseInt(item.ACTIVE) + parseInt(item.INACTIVE),
                    state: item["master.state"],
                    potential_clients: parseInt(item.POTENTIAL),
                    total:
                        parseInt(item.ACTIVE) +
                        parseInt(item.INACTIVE) +
                        parseInt(item.POTENTIAL),
                    ACTIVE: parseInt(item.ACTIVE),
                    INACTIVE: parseInt(item.INACTIVE),
                };
            });

            // modalityFilterData=handleModalityChange(modalityFilterData)
            setTableData(modalityFilterData);
            // //console.log(modalityFilterData)

            let statistic;
            if (mapStatistic === "clients") {
                statistic = "potential_clients";
            } else if (mapStatistic === "onboard") {
                statistic = "onboarded_clients";
            } else if (mapStatistic === "active") {
                statistic = "ACTIVE";
            } else {
                statistic = "INACTIVE";
            }
            const potentialClientsByState = accumulateValuesByState(
                modalityFilterData,
                statistic
            );
            // //console.log(potentialClientsByState)
            const potentialClientsArray = convertToObjectArray(
                potentialClientsByState
            );
            // //console.log(potentialClientsArray)

            setMapData(potentialClientsByState);
        }
    }, [data, mapStatistic, mapCode, districtView]);

    useEffect(() => {
        if (districtView) {
            let statistic;
            if (mapStatistic === "clients") {
                statistic = "potential_clients";
            } else if (mapStatistic === "onboard") {
                statistic = "onboarded_clients";
            } else if (mapStatistic === "active") {
                statistic = "ACTIVE";
            } else {
                statistic = "INACTIVE";
            }
            const processedData = {};

            let modalityFilterData = modalityDistrictData?.map((item) => {
                const stateName = item["master.state"];
                const stateCode = Object.keys(STATE_NAMES).find(
                    (key) => STATE_NAMES[key] === stateName
                );
                return {
                    ...item,
                    stateCode: stateCode || "UNASSIGNED",
                };
            });

            modalityFilterData = modalityFilterData?.map((item) => {
                return {
                    ...item,
                    onboarded_clients: parseInt(item.ACTIVE) + parseInt(item.INACTIVE),
                    state: item["master.state"],
                    district: item["measures"],
                    potential_clients: parseInt(item.POTENTIAL),
                    total:
                        parseInt(item.ACTIVE) +
                        parseInt(item.INACTIVE) +
                        parseInt(item.POTENTIAL),
                    ACTIVE: parseInt(item.ACTIVE),
                    INACTIVE: parseInt(item.INACTIVE),
                };
            });

            setDistrictData(modalityFilterData);
            // //console.log(modalityFilterData)

            modalityFilterData?.forEach((entry) => {
                const districtName = entry["district"]?.replace(/\b\w/g, (char) =>
                    char.toUpperCase()
                );
                if (entry?.stateCode === mapCode) {
                    processedData[districtName] = entry[statistic];
                    // {
                    //   ...entry,
                    //   "p.state": entry["p.state"],
                    //   "p.district": districtName,
                    //   "total": entry["total"],
                    //   "onboarded_clients": entry["onboarded_clients"],
                    //   "potential_client": entry["potential_client"],
                    //   "ACTIVE": entry["ACTIVE"],
                    //   "INACTIVE": entry["INACTIVE"],
                    // };
                }
            });

            // //console.log(processedData)

            let data = {};
            data[mapCode] = {
                district: processedData,
            };

            setMapDistrictData(data);
        }
    }, [
        mapStatistic,
        mapCode,
        districtView,
        modalityDistrictData,
        modalityCheck?.length,
    ]);

    const toggleTheme = () => {
        if (theme === "dark-theme") {
            setTheme("light-theme");
        } else {
            setTheme("dark-theme");
        }
    };
    useEffect(() => {
        document.body.className = theme;
    }, [theme]);

    useEffect(() => {
        if (districtView) {
            setRegionHighlighted({
                stateCode: mapCode,
                districtName: null,
                value: cardData[mapStatistic === "clients" ? "client" : mapStatistic],
            });
        } else {
            setRegionHighlighted({
                stateCode: "TT",
                districtName: null,
                value: cardData[mapStatistic === "clients" ? "client" : mapStatistic],
            });
        }
    }, [data, mapStatistic, mapCode, districtView, cardData]);

    // useEffect(()=>{
    //   if(mapCode=='TT'){
    //     setDistrictView(false)
    //   }else{
    //     setDistrictView(true)
    //   }
    // },[mapCode])

    return (
        <div>
            <div className="home">
                <div className="left">
                    <div className="theme-selector">
                        <div>
                        <div>
                            {theme === "dark-theme" ? (
                                <svg
                                    onClick={() => toggleTheme()}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#ffc107"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <circle cx="12" cy="12" r="5"></circle>
                                    <line x1="12" y1="1" x2="12" y2="3"></line>
                                    <line x1="12" y1="21" x2="12" y2="23"></line>
                                    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                                    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                                    <line x1="1" y1="12" x2="3" y2="12"></line>
                                    <line x1="21" y1="12" x2="23" y2="12"></line>
                                    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                                    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                                </svg>
                            ) : (
                                <svg
                                    onClick={() => toggleTheme()}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                                </svg>
                            )}
                        </div>

                        <div style={{marginTop:'20px'}}>
                            { accessLevel?.scope==='internal' &&
                            <BsClipboard2DataFill color={theme === "dark-theme" && "white"} size={20} style={{cursor:'pointer'}} onClick={()=>{
                                navigate('/contribution/my')
                            }} />
                        }
                        </div>
                        </div>
                        <div onClick={() => handleLogout()} style={{ display: 'flex', alignItems: 'center',cursor:'pointer',zIndex:99 }}>
                            Sign Out
                            <MdOutlineLogout style={{ marginLeft: '5px' }} />
                        </div>



                    </div>
                    {/* <div>
                        Logout
                    </div> */}
                    <Suspense fallback={<div style={{ height: "50rem" }} />}>
                        <article class="c-article"></article>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <LeftSideSummary
                            clientData={clientData}
                                modalityCheck={modalityCheck}
                                indiaCard={indiaCard}
                                setRegionHighlighted={setRegionHighlighted}
                                setMapStatistic={setMapStatistic}
                                setMapCode={setMapCode}
                                mapCode={mapCode}
                                districtData={districtData}
                                isDistrictView={districtView}
                                setDistrictView={setDistrictView}
                                cardData={cardData}
                                data={tableData}
                                setClientTableExpand={setClientTableExpand}
                                {...{ mapStatistic, setMapStatistic }}
                            />
                        </div>
                    </Suspense>
                </div>

                <div className="right">
                    <MapTool
                        email={email}
                        mapStatistic={mapStatistic}
                        setMapStatistic={setMapStatistic}
                        modalityCheck={modalityCheck}
                        setModalityCheck={setModalityCheck}
                        cardData={cardData}
                        regionHighlighted={regionHighlighted}
                        isDistrictView={districtView}
                    />
                    <Suspense fallback={<div style={{ height: "50rem" }} />}>
                        <Map
                            transformStatistic={transformStatistic}
                            districtData={districtMapData}
                            mapCode={mapCode}
                            data={mapData}
                            cardData={cardData}
                            mapStatistic={mapStatistic}
                            setMapStatistic={setMapStatistic}
                            regionHighlighted={regionHighlighted}
                            setRegionHighlighted={setRegionHighlighted}
                            isDistrictView={districtView}
                        />
                    </Suspense>
                </div>
            </div>

            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <ClientsTable
                    clientData={clientData}
                    mapStatistic={mapStatistic}
                    regionHighlighted={regionHighlighted}
                    isDistrictView={districtView}
                    clientTableExpand={clientTableExpand}

                />
            </div>
        </div>
    );
}

export default Home;
